<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16.0004"
      cy="16.0004"
      r="8.85"
      stroke="#0078CF"
      stroke-opacity="0.8"
      stroke-width="1.5"
    />
    <circle
      cx="16"
      cy="16"
      r="15.25"
      stroke="#0078CF"
      stroke-opacity="0.4"
      stroke-width="1.5"
    />
    <circle
      cx="15.9998"
      cy="16.0008"
      r="3.2"
      fill="#0078CF"
    />
    <circle
      cx="23"
      cy="23"
      r="9"
      fill="#74CD1B"
    />
    <path
      d="M26.6009 20.4561L21.7468 25.4835C21.5502 25.6871 21.224 25.6871 21.0274 25.4835L19.4009 23.7989"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>